<template>
    <div class="form-group" v-if="itemSecond">
        <hr />
        <label class="font-weight-normal" for="confirmation">
            Please type
            <code class="px-2">{{ this.confirmationText }}</code> in the box
            below and click continue if you wish to proceed with the merge of
            <strong class="font-italic">{{ itemFirst }}</strong> into
            <strong class="font-italic">{{ itemSecond }}</strong>
        </label>
        <input
            v-model="confirmation"
            name="confirmation"
            class="form-control"
            :class="{
                'border-danger': formErrors.includes('confirmation')
            }"
        />
    </div>
</template>
<script>
export default {
    props: {
        textMessage: {
            type: String,
            default: ""
        },
        module: {
            String,
            required: true,
            validator: function (value) {
                return ["client", "patient", "item"].indexOf(value) !== -1;
            }
        },
        itemFirst: {
            type: String,
            default: null
        },
        itemSecond: {
            type: String,
            default: null
        }
    },
    computed: {
        message() {
            return `To confirm merging, enter <strong>"${this.confirmationText}"</strong> in below field`;
        },
        confirmationText() {
            return `merge`;
        },
        isConfirmationTextMatch() {
            return this.confirmation === this.confirmationText;
        }
    },
    data() {
        return {
            confirmation: "",
            formErrors: []
        };
    },
    watch: {
        confirmation(value) {
            this.removeErrors("confirmation");
            this.$emit("is-matched", this.isConfirmationTextMatch);
        },
        itemSecond(value) {
            if (value) {
                this.removeErrors("confirmation");
            }
        }
    },
    methods: {
        isValid() {
            const isConfirmationValid =
                this.confirmation === this.confirmationText;

            if (!isConfirmationValid) {
                this.formErrors.push("confirmation");
            }
            return isConfirmationValid;
        },
        removeErrors(key) {
            this.formErrors = this.formErrors.filter(err => err !== key);
        }
    }
};
</script>
